// extracted by mini-css-extract-plugin
export var button = "_dc-7";
export var buttonRow = "_dc-6";
export var fadeIn = "_dc-1";
export var gradient = "_dc-0";
export var panel = "_dc-2";
export var panelIn = "_dc-3";
export var subtitle = "_dc-5";
export var title = "_dc-4";